<template>
  <div
    class="modal fade"
    id="elementHistoryModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ title }}</b>
          </h4>
          <label v-if="elementId" class="control-label nopadding"
            >ID: {{ elementId }}</label
          >
        </div>
        <div class="modal-body">
          <div class="element-history-modal-content">
            <table v-if="history.length > 0" class="table">
              <thead>
                <tr>
                  <th class="text-left" style="width: 30%">
                    {{ lang.HIS000 }}
                  </th>
                  <th class="text-left" style="width: 70%">
                    {{ lang.HIS001 }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="entry in history"
                  :key="entry.SurveyInstanceHistoryGuid"
                >
                  <td class="text-left">
                    <b>{{ entry.EntryCreatedByDisplayName }}</b>
                    <br />
                    <span class="entry-creation-timestamp">{{
                      globals.getLocalizedDateTimeFromUtcIsoTimestamp(
                        entry.EntryCreatedAt
                      )
                    }}</span>
                  </td>
                  <td class="text-left">{{ entry.Message }}</td>
                </tr>
              </tbody>
            </table>
            <span v-else>{{ lang.HIS002 }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.HIS003 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ElementHistoryModal",
  data() {
    return {
      title: "",
      elementId: 0,
      history: [],
      lang: {
        HIS000: "Info",
        HIS001: "Action",
        HIS002: "No history entries available.",
        HIS003: "Close",
        HIS004: "Check History",
        HIS005: "Location History",
        HIS006: "History data request failed",
      },
    };
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.$off("showElementHistory");
    this.globals.$on("showElementHistory", (config) => {
      this.getElementHistory(config);
    });
  },
  methods: {
    openModal() {
      $("#elementHistoryModal").modal("show");
    },
    closeModal() {
      $("#elementHistoryModal").modal("hide");
    },
    getElementHistory(config) {
      if (!config) return;
      let query = "";

      if (config.type === "SurveyInstance") {
        query = `api/SurveyInstanceHistory/${config.guid}`;
        this.title = this.lang.HIS004;
      } else if (config.type === "Location") {
        query = `api/LocationHistory/${config.guid}`;
        this.title = this.lang.HIS005;
      }

      if (!query) {
        console.error("History config error");
        return;
      }

      this.elementId = config.id;
      this.history = [];

      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data[0]) this.history = data;
          this.openModal();
        },
        error: (error) => {
          console.error("Error on GET in getElementHistory()");
          this.globals.showErrorSnackbar(this.lang.HIS006);
        },
      });
    },
  },
};
</script>

<style scoped>
.modal-body {
  padding: 10px;
}
.element-history-modal-content {
  max-height: calc(100vh - 195px);
  overflow: auto;
}
.entry-creation-timestamp {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// ElementHistoryModal.vue?acef64a0